import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_food_new_products: FaireCategoryEntity = {
  token: "cat_food-new-products",
  type: "category",
  name: "New products",
  level: 2,
  parentToken: "cat_food-drink",
  href: "/category/food-drink/new-products",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
